import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Homepage from "../pages/common/home-page";
import LandingPage from "../pages/common/LandingPage";
import LoginPage from "../pages/common/login-page";
import RegisterPage from "../pages/common/register-page";
import PrivacyPolicyPage from "../pages/common/privacy-policy-page";
import TermOfUsePage from "../pages/common/term-of-use-page";
import AdminFilesPage from "../pages/admin/admin-files-page";
import JiffyOrdersPage from "../pages/admin/jiffy-orders-page";
import ProtectedRoute from "./protected-route";
import MyFilesPage from "../pages/user/MyFilesPage";
import HoustonOrdersPage from "../pages/admin/houston-orders-page";
import DallasOrdersPage from "../pages/admin/dallas-orders-page";
import DallasInventoryPage from "../pages/admin/dallas-inventory-page";
import AccountingReport from "../pages/admin/AccountingReport";
import MyOrdersPage from "../pages/common/MyOrdersPage";
import OrderDetailsPage from "../pages/common/OrderDetailsPage";
import AdminUsersPage from "../pages/admin/AdminUsersPage";
import AdminOrdersPage from "../pages/admin/OrdersManagementPage";
import AdminOrderDetailsPage from "../pages/admin/AdminOrderDetailsPage";
import InventoryPage from "../pages/common/InventoryPage";
import ForgotPasswordPage from "../pages/common/ForgotPasswordPage";
import ResetPasswordPage from "../pages/common/ResetPasswordPage";
import CreateGangsheet from "../pages/admin/CreateGangsheet";
import ProfilePage from "../pages/common/ProfilePage";
import MockupEditorPage from "../pages/admin/MockupEditorPage";
import OklahomaOrdersPage from "../pages/admin/oklohoma-orders-page";
import ProductionStatsPage from "../pages/admin/ProductionStatsPage";
import UncommittedOrdersPage from "../pages/admin/UncommittedOrdersPage";
import EmbroideryOrdersPage from "../pages/admin/EmbroideryOrdersPage";
import EmbroideryMyOrdersPage from "../pages/admin/EmbroideryMyOrdersPage";
import EmbroideryOrderDetailsPage from "../pages/common/EmbroideryOrderDetailsPage";
import MyTasksPage from "../pages/common/MyTasksPage";
import AdminTaskManagementPage from "../pages/admin/AdminTaskManagementPage";
import CAOrdersPage from "../pages/admin/ca-orders-page";
import TicketsPage from "../pages/common/TicketsPage";
import JiffyReportsPage from "../pages/admin/JiffyReportsPage";

const CustomRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route index element={<LoginPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route
            path="home"
            element={
              <ProtectedRoute>
                <LandingPage />
              </ProtectedRoute>
            }
          />
          {/* ✅ Jiffy Kullanıcıları için Orders Sayfaları - admin pathi OLMADAN */}
          <Route
            path="ca-orders"
            element={
              <ProtectedRoute
                allowedEmails={["jiffyca@txmaya.com", "mhmtmnctl20@gmail.com"]}
              >
                <CAOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="houston-orders"
            element={
              <ProtectedRoute
                allowedEmails={[
                  "houstonorders@txmaya.com",
                  "admin@txmaya.com",
                  "mhmtmnctl20@gmail.com",
                ]}
              >
                <HoustonOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="dallas-orders"
            element={
              <ProtectedRoute
                allowedEmails={[
                  "dallasorders@txmaya.com",
                  "mhmtmnctl20@gmail.com",
                ]}
              >
                <DallasOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="dallas-inventory"
            element={
              <ProtectedRoute
                allowedEmails={[
                  "dallasorders@txmaya.com",
                  "mhmtmnctl20@gmail.com",
                ]}
              >
                <DallasInventoryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="oklahoma-orders"
            element={
              <ProtectedRoute
                allowedEmails={["jiffyokc@txmaya.com", "mhmtmnctl20@gmail.com"]}
              >
                <OklahomaOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="send-files"
            element={
              <ProtectedRoute>
                <Homepage />
              </ProtectedRoute>
            }
          />
          {/* ✅ Forgot Password */}
          <Route path="forgot-password" element={<ForgotPasswordPage />} />
          {/* ✅ Reset Password */}
          <Route path="reset-password" element={<ResetPasswordPage />} />
          <Route
            path="admin/users"
            element={
              <ProtectedRoute allowedEmails={["mhmtmnctl20@gmail.com"]}>
                <AdminUsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin-orders"
            element={
              <ProtectedRoute allowedEmails={["mhmtmnctl20@gmail.com"]}>
                <AdminOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/task-management"
            element={
              <ProtectedRoute allowedEmails={["mhmtmnctl20@gmail.com"]}>
                <AdminTaskManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/production-stats"
            element={
              <ProtectedRoute
                allowedEmails={["admin@txmaya.com", "mhmtmnctl20@gmail.com"]}
              >
                <ProductionStatsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/jiffy-reports"
            element={
              <ProtectedRoute
                allowedEmails={["admin@txmaya.com", "mhmtmnctl20@gmail.com"]}
              >
                <JiffyReportsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin-order-details/:orderId"
            element={
              <ProtectedRoute allowedEmails={["mhmtmnctl20@gmail.com"]}>
                <AdminOrderDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="my-files"
            element={
              <ProtectedRoute>
                <MyFilesPage />
              </ProtectedRoute>
            }
          />
          {/* ✅ Profile route */}
          <Route
            path="profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          {/* ✅ My Tasks route - Belirli kullanıcılar hariç */}
          <Route
            path="my-tasks"
            element={
              <ProtectedRoute employeesOnly={true}>
                <MyTasksPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/task-management"
            element={
              <ProtectedRoute allowedEmails={["mhmtmnctl20@gmail.com"]}>
                <AdminTaskManagementPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="tickets"
            element={
              <ProtectedRoute>
                <TicketsPage />
              </ProtectedRoute>
            }
          />
          <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="website-terms-of-use" element={<TermOfUsePage />} />
          <Route
            path="admin/files"
            element={
              <ProtectedRoute
                allowedEmails={["admin@txmaya.com", "mhmtmnctl20@gmail.com"]}
              >
                <AdminFilesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/jiffy-orders"
            element={
              <ProtectedRoute
                allowedEmails={["admin@txmaya.com", "mhmtmnctl20@gmail.com"]}
              >
                <JiffyOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/uncommitted-orders"
            element={
              <ProtectedRoute allowedEmails={["mhmtmnctl20@gmail.com"]}>
                <UncommittedOrdersPage />
              </ProtectedRoute>
            }
          />
          {/* ESKİ admin orders route'ları - SİLİNECEK veya COMMENT */}
          {/* 
          <Route
            path="admin/houston-orders"
            element={
              <ProtectedRoute
                allowedEmails={[
                  "houstonorders@txmaya.com",
                  "mhmtmnctl20@gmail.com",
                ]}
              >
                <HoustonOrdersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="admin/dallas-orders"
            element={
              <ProtectedRoute
                allowedEmails={[
                  "dallasorders@txmaya.com",
                  "mhmtmnctl20@gmail.com",
                ]}
              >
                <DallasOrdersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="admin/oklahoma-orders"
            element={
              <ProtectedRoute
                allowedEmails={["jiffyokc@txmaya.com", "mhmtmnctl20@gmail.com"]}
              >
                <OklahomaOrdersPage />
              </ProtectedRoute>
            }
          />
          */}
          <Route
            path="admin/embroidery-orders"
            element={
              <ProtectedRoute
                allowedEmails={[
                  "embroidery@txmaya.com",
                  "mhmtmnctl20@gmail.com",
                ]}
              >
                <EmbroideryOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="embroidery-my-orders"
            element={
              <ProtectedRoute
                allowedEmails={[
                  "embroidery@txmaya.com",
                  "mhmtmnctl20@gmail.com",
                ]}
              >
                <EmbroideryMyOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="embroidery-order/:orderId"
            element={
              <ProtectedRoute
                allowedEmails={[
                  "embroidery@txmaya.com",
                  "mhmtmnctl20@gmail.com",
                ]}
              >
                <EmbroideryOrderDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="report"
            element={
              <ProtectedRoute
                allowedEmails={[
                  "fuatsaglam1983@gmail.com",
                  "mhmtmnctl20@gmail.com",
                ]}
              >
                <AccountingReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="my-orders"
            element={
              <ProtectedRoute>
                <MyOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/order-details/:orderId"
            element={<OrderDetailsPage />}
          />
        </Route>

        <Route path="inventory" element={<InventoryPage />} />

        <Route
          path="admin/mockup-editor"
          element={
            <ProtectedRoute allowedEmails={["mhmtmnctl20@gmail.com"]}>
              <MockupEditorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="admin/create-gangsheet"
          element={
            <ProtectedRoute
              allowedEmails={["mhmtmnctl20@gmail.com", "admin@txmaya.com"]}
            >
              <CreateGangsheet />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default CustomRoutes;
